import axios from 'axios'
// import qs from 'qs' , base64
import utils from './indexs'
import { aes } from './crypto'
/* axios.defaults.withCredentials = true
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN
axios.defaults.headers.post['Content-Type'] = 'application/jsoncharset=utf-8'// 配置请求头 */
import * as config from '@/config/env'
let bindToGlobal = (obj, key='var') => {
    if (typeof window[key] === 'undefined') {
        window[key] = {};
    }
    for (let i in obj) {
        window[key][i] = obj[i]
    }
}
window.bindToGlobal = bindToGlobal   //定义全局方法：绑定全局参数
bindToGlobal(config, '$config')
axios.defaults.timeout = 5000
// axios.defaults.baseURL = baseUrl
    // axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.withCredentials = true
axios.defaults.cache = false
    // http request 拦截器
axios.interceptors.request.use(
        config => {
            config.credentials = true
            config.headers = {
                'Content-Type': 'application/json'
                    /* 'accessToken': utils.getToken()*/
            }
            return config
        },
        err => {
            return Promise.reject(err)
        }
    )
    /*消息推送*/
const postNotice = (url, params, level) => {
        return axios.post($config.noticeBaseUrl + url, params)
    }
    /*工作流get请求*/
const getWorkflow = (url, params) => {
        return axios.get($config.workflowBaseUrl + url, params)
    }
    /* get请求 */
const get = (url, params, level) => { return axios.get($config.baseUrl + url, getConfig(params, level)) }
    /* baseUrlFile=== get请求 */
const getfile = (url, params, level) => { return axios.get($config.baseUrlFile + url, getConfig(params, level)) }
const getAse = (url, params, level) => { return axios.get($config.baseUrl + url, getConfig(params, level)) }
    /* get门户请求 */
const getmh = (url, params, level) => { return axios.get($config.mhbaseUrl + url, getConfig(params, level)) }
    /* 门户请求post */
const postmh = (url, params, level) => { return axios.post($config.mhbaseUrl + url, params) }
    /* 门户请求post */
const DELETEMH = (url, params, level) => {
        return axios.delete($config.mhbaseUrl + url, params)
    }
    /* get设备请求 */
// const getdv = (url, params, level) => { return axios.get(dvbaseUrl + url, getConfig(params, level)) }

/*  post请求 */
const post = (url, params, level) => { return axios.post($config.baseUrl + url, params) }
    /* 加密post请求 */
const postAse = (url, params, level) => { return axios.post($config.baseUrl + url, getPostConfig(params, level)) }
    /* delete请求 */
const DELETE = (url, params, level) => { return axios.delete($config.baseUrl + url, params) }
    /* baseUrlFile=== delete请求 */
const DELETEFILE = (url, params, level) => { return axios.delete($config.baseUrlFile + url, params) }
    /* put请求 */
const put = (url, params, level) => { return axios.put($config.baseUrl + url, params) }
    /* put请求 */
const patch = (url, params, level) => { return axios.patch($config.baseUrl + url, params) }

/** ******************** [attachmentUrl] ********************/
/* get附件管理请求 */
const getAt = (url, params, level) => {
    return axios.get($config.attachmentUrl + url, getConfig(params, level)) }
    /* 附件管理请求post */
const postAt = (url, params, level) => { return axios.post($config.attachmentUrl + url, params) }
    /* 附件管理请求post */
const DELETEAt = (url, params, level) => {
        return axios.delete($config.attachmentUrl + url, params)
    }
    /* 参数配置 */
const getConfig = (params, level = 0) => {
    const paramsTemp = params || {}
    const config_ = {
        emulateJSON: true,
        params: paramsTemp,
        timeout: 200000,
        credentials: true,
        headers: {
            token: utils.getToken()
        }
    }
    if (level === 1) { // 加密
        params.password = aes.en(params.password)
        config_.params = params
    } else if (level === 2) { // 修改密码加密
        params.newPassword = aes.en(params.newPassword)
        params.oldPassword = aes.en(params.oldPassword)
        config_.params = params
    }
    return config_
}
const getPostConfig = (params, level = 0) => {
    if (level === 1) { // 加密
        params.password = aes.en(params.password)
    }
    return params
}
export {
    postNotice,
    get,
    getfile,
    getAse,
    getmh,
    postmh,
    DELETEMH,
    getdv,
    post,
    postAse,
    DELETE,
    DELETEFILE,
    put,
    patch,
    getWorkflow,
    getAt,
    postAt,
    DELETEAt
}


// WEBPACK FOOTER //
// ./src/utils/http.js